/*
 * @Author: your name
 * @Date: 2020-12-15 11:15:42
 * @LastEditTime: 2021-01-08 11:26:51
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \yzjomc-web\src\config\api.js
 */
export default {
  GETPUSHMESSAGE: '/guard-genius/eyeProtect/getEyeProtectDataForNew',
  GETQUESTIONLIST: '/tutor-online/app/question/getSubUserQuestionList'
}



// WEBPACK FOOTER //
// ./src/config/api.js